export default __webpack_public_path__ + "static/tip2-fc8de933692a49641282b256a34c701f.png";